import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, forwardRef, Input, OnChanges, ViewEncapsulation, Injector, NgModule, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { Entity, OpportunityStage, OpportunitySystemStage } from '@jms/model';
import { PickerItemModule, PickerItemStyle } from '@jms/ui/ui.picker.item';
import { PickerBaseComponent, PickerFetch } from '@jms/ui/ui.pickers.base';
import { NgSelectModule } from '@ng-select/ng-select';
import * as Enumerable from 'linq';
import { Observable, of, map } from 'rxjs';

@Component({
    selector: 'opportunity-stage-picker',
    templateUrl: './stage.picker.component.html',
    styleUrls: ['./stage.picker.component.less'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => OpportunityStagePickerComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OpportunityStagePickerComponent extends PickerBaseComponent implements OnChanges {

    @Input() public data: OpportunityStage[];
    @Input() public placeholder = '<Opportunity Stage>';
    @Input() public multiple = false;
    @Input() public allowClear = false;
    @Input() public appendTo;
    @Input() public selectableGroup = false;
    @Input() public allowClose = true;

    public data$: Observable<OpportunityStage[]>;
    public PickerItemStyle = PickerItemStyle;

    constructor(
        cdr: ChangeDetectorRef,
        injector: Injector,
        private http: HttpClient
    ) {
        super(injector);
    }

    public ngOnChanges() {

        const data$ = this.fetch === PickerFetch.Automatic
            ? this.getLabels()
            : of(this.data);

        this.data$ = data$.pipe(map(x => this.updateOrder(x)));

    }

    private getLabels(): Observable<OpportunityStage[]> {
        return this.http.get<OpportunityStage[]>(`/api/opportunities/stages`)
    }


    public compareFn(data1: Entity, data2: Entity): Boolean {
        if (!data1?._id || !data2?._id) {
            return false;
        }

        const same = data1?._id === data2?._id;
        return same;
    }


    public getGroup(groupKey: string, children: any[]) {

        const group = {
            _id: groupKey,
            name: `${groupKey}: All`,
            systemStage: groupKey,
            systemGroup: true
        }

        return group;
    }

    private updateOrder(stages: OpportunityStage[] = []): OpportunityStage[] {

        const openStages = Enumerable
            .from(stages)
            .where(x => x.systemStage === OpportunitySystemStage.Open)
            .orderBy(x => parseInt(x?.probability as any ?? 0))
            .toArray();


        const closedStages = this.allowClose
            ? Enumerable
                .from(stages)
                .where(x => x.systemStage === OpportunitySystemStage.Closed)
                .orderBy(x => parseInt(x?.probability as any ?? 0))
                .toArray()
            : [];

        const items = [...openStages, ...closedStages];

        return items;
    }

}

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgSelectModule,
        PickerItemModule,
    ],
    declarations: [
        OpportunityStagePickerComponent
    ],
    providers: [],
    exports: [
        OpportunityStagePickerComponent
    ],
})
export class OpportunityStagePickerModule { }
